<div>
  <mat-label class="label-box font-weight-bold" *ngIf="attachments && attachments.length > 0">
    {{'components.proposals.new-proposal.loaded-attachments' | translate}}
  </mat-label>

  <div class="attachment-row"
       *ngFor="let attachment of attachments; let attachIndex = index">
                                      <span class="name">
                                          <i class="icon-pdf"></i>
                                          <a [href]="attachment.link" target="_blank">{{attachment.title}}</a>
                                      </span>
    <span class="size float-right">
                                          {{'generic.buttons.delete' | translate}}
      <i class="icon-cestino main-color"
         (click)="onRemoveAttachment(attachIndex)"></i>
                                      </span>
  </div>

  <div class="col-12 links-container">
    <button mat-button type="button" color="primary" [matMenuTriggerFor]="attachmentMenu">
      <i class="icon-upload mr-2"></i>
      {{'generic.buttons.load-attach' | translate}}
    </button>
    <mat-menu #attachmentMenu="matMenu">
      <button mat-menu-item *ngFor="let type of allowedAttachmentTypes" (click)="onAddAttachment(type)">
        <mat-icon aria-hidden="false">file_upload</mat-icon>
        {{ type }}
      </button>
    </mat-menu>
  </div>
</div>
